import { Suspense, lazy } from "react";
import { Navigate, NonIndexRouteObject, Outlet } from "react-router-dom";
import { ClientLayout, AdminLayout } from "src/layout";
import {
  ApiDocsPage,
  ClientPage,
  ProductDetailPage,
  ProductPage,
  ScannerPage,
  ServiceStatusPage,
  SpuConverterPage,
} from "src/pages";
import {
  FinalyRegistrationPage,
  LoginPage,
  RegistrationPage,
  VerifyPage,
} from "src/pages/Authentificate";
import { ResetPwdPage } from "src/pages/Authentificate/ResetPwdPage/ResetPwdPage";
import { RestorePwdPage } from "src/pages/Authentificate/RestorePwdPage/RestorePwdPage";
import { YaAuthPage } from "src/pages/Authentificate/YaAuthPage";
import { ErrorBoundary } from "src/pages/ErrorBoundary";
import { ExportPage } from "src/pages/ExportPage";
import { ExportTaskWidget } from "src/pages/ExportPage/widgets";
import { ProfilePage } from "src/pages/ProfilePage";
import { PoizonOrderListWidget } from "src/pages/ProfilePage/widgets";
import { SubscribePage } from "src/pages/SubscribePage";
import { SubscribePage as SubscribePageOld } from "src/pages/SubscribePageDeprecated";
import { RoutesPaths } from "src/routes/RoutesPaths.ts";
import { RouterWrapper } from "src/widgets";
import {
  KnowledgeBaseArticle,
  KnowledgeBaseFallbackRoute,
  KnowledgeBaseFirstArticleRedirect,
  KnowledgeBaseLayoutLk,
} from "src/widgets/KnowledgeBase";
import { ARTICLE_ROUTE, routePath } from "src/widgets/KnowledgeBase/constants";

import {
  AdminProtectedRoute,
  NonAuthProtectedRoute,
  ProtectedRoute,
} from "./Protected.route";

const AdminDashboardPage = lazy(() =>
  import("src/pages/AdminDashboardPage/AdminDashboardPage").then((mod) => ({
    default: mod.AdminDashboardPage,
  })),
);
const AdminUserPage = lazy(() =>
  import("src/pages/AdminUserPage/AdminUserPage").then((mod) => ({
    default: mod.AdminUserPage,
  })),
);

export const AuthRoutes: NonIndexRouteObject[] = [
  {
    path: RoutesPaths.LK.BASE_PATH,
    element: <RouterWrapper />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        element: <ProtectedRoute />,
        children: [
          {
            element: (
              <ClientLayout>
                <ClientPage />
              </ClientLayout>
            ),
            children: [
              {
                index: true,
                element: <Navigate to={"profile"} replace />,
              },
              {
                path: RoutesPaths.LK.PROFILE.BASE_PATH,
                element: <ProfilePage />,
              },
              {
                path: RoutesPaths.LK.CLIENT_ORDERS(":clientId"),
                element: <PoizonOrderListWidget />,
              },
              { path: RoutesPaths.LK.GOODS, element: <ProductPage /> },
              {
                path: RoutesPaths.LK.PRODUCT(":productId"),
                element: <ProductDetailPage />,
              },
              {
                path: RoutesPaths.LK.EXPORT,
                element: <ExportPage />,
              },
              {
                path: RoutesPaths.LK.EXPORT_TASK(":taskId"),
                element: <ExportTaskWidget />,
              },
              { path: RoutesPaths.LK.CONVERTER, element: <SpuConverterPage /> },
              {
                path: `${RoutesPaths.LK.API_DOCS}/:tab?`,
                element: <ApiDocsPage />,
              },
              {
                path: routePath.lk,
                element: <KnowledgeBaseLayoutLk />,
                children: [
                  {
                    index: true,
                    element: <KnowledgeBaseFirstArticleRedirect />,
                  },
                  {
                    path: ARTICLE_ROUTE,
                    element: <KnowledgeBaseArticle />,
                  },
                  {
                    path: "*",
                    element: <KnowledgeBaseFallbackRoute />,
                  },
                ],
              },
              { path: RoutesPaths.LK.SCANNER, element: <ScannerPage /> },
              {
                path: RoutesPaths.LK.SUBSCRIBE,
                element: <SubscribePage />,
              },
              {
                path: RoutesPaths.LK.SUBSCRIBE_OLD,
                element: <SubscribePageOld />,
              },
              {
                path: RoutesPaths.LK.SERVICE_STATUS,
                element: <ServiceStatusPage />,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "/admin",
    element: <RouterWrapper />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        element: <AdminProtectedRoute />,
        children: [
          {
            element: (
              <AdminLayout>
                <Outlet />
              </AdminLayout>
            ),
            children: [
              {
                index: true,
                element: <Navigate to={"dashboard"} replace />,
              },
              {
                path: "dashboard",
                element: (
                  <Suspense fallback={null}>
                    <AdminDashboardPage />
                  </Suspense>
                ),
              },
              {
                path: "clients/:userId",
                element: (
                  <Suspense fallback={null}>
                    <AdminUserPage />
                  </Suspense>
                ),
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "/authorization",
    element: <RouterWrapper />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        element: <NonAuthProtectedRoute />,
        children: [
          {
            index: true,
            element: <Navigate to={"login"} replace={true}></Navigate>,
          },
          {
            path: "login",
            element: <LoginPage />,
          },
          {
            path: "reg",
            children: [
              { index: true, element: <RegistrationPage /> },
              {
                path: "finaly",
                element: <FinalyRegistrationPage />,
              },
            ],
          },
          {
            path: "restorePassword",
            element: <RestorePwdPage />,
          },
          {
            path: "resetPassword",
            element: <ResetPwdPage />,
          },
          {
            path: "verify",
            element: <VerifyPage />,
          },
          {
            path: "yaAuth",
            element: <YaAuthPage />,
          },
        ],
      },
    ],
  },
];
